// Private message channel from the login frame back to the parent app.
//
// The app hands the login frame one MessagePort (a MessageChannel port transferred once at
// startup); from then on every login→app message (requestCurrentToken / ready / reauthSuccess /
// panic) travels only over that port. A port is a capability: any other frame embedded in the app
// (cover sites, external apps, the reader) never receives it, so it can neither inject a forged
// handshake message nor eavesdrop on the token/key that crosses on success. This matters most on a
// single shared static-host origin, where every bucket is same-origin and an origin check between
// them is meaningless — only holding the port distinguishes the real login.
//
// The login stores the port here so the shared signin flow (slices/signinRequest) can post its
// reauth-invalidated "panic" without threading the port through its call signature. In the main-app
// context (which imports the same signin flow but never runs inside the auth frame) no port is ever
// set, so postToApp is a no-op there.
let port = null;

export const setAppPort = (p) => {
  port = p;
};

export const postToApp = (message) => {
  port?.postMessage(message);
};
